<script>
import options from './ProductCard.options'
export default options
</script>

<template>
  <a class="kb-product-card" :href="data.url" @click="handleCardClick">

    <figure class="kb-product-card__image kb-image-module--5-4">
      <div class="kb-image-module__image-container">
        <picture class="kb-image-module__image">
          <source :srcset="desktopImageUrl" media="(min-width: 475px)">
          <source :srcset="mobileImageUrl" media="(max-width: 475px)">
          <img :alt="data.imageAlt ?? ''">
        </picture>
      </div>
      <template v-if="data.saleLabelText">
        <div class="kb-product-card__sale-label" :class="data.labelColorTheme">
          {{ data.saleLabelText }}
        </div>
      </template>

    </figure>

    <div class="kb-product-card__content">

      <h3 class="kb-product-card__title">
        {{ data.title }}
      </h3>

      <div class="kb-product-card__content-wrapper">
        <div class="kb-product-card__price-wrapper">
          <p class="kb-product-card__price">
            {{ data.displayPrice }}
          </p>
  
          <template v-if="data.displayBeforePrice">
            <p class="kb-product-card__price--before">
              Førpris
              <span class="kb-product-card__price--before-line-through">{{ data.displayBeforePrice }}</span>
            </p>
          </template>
  
        </div>
        <template v-if="showAddCta">
            <button class="kb-product-card__cta" v-if="!isAdded" @click.prevent="addToCart">
              <span class="kb-visually-hidden">Tilføj vare til kurv</span>
              <svg role="presentation" width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.5 11.5h-22l3 16h17l2-16Zm0 0h7l-3 16H26M3 19.5h26M10.5 27.5l-2-16M16.5 11.5v16M10.5 9.5l1-5h9l1 5" stroke="#3C3C3C"></path>
              </svg>
            </button>
            <button class="kb-product-card__cta kb-product-card__cta--disabled" v-else>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="32" height="32">
                <path d="M8 17.739 14 24 24 8" stroke="#3c3c3c" stroke-linejoin="round" stroke-width="2"/>
              </svg>
            </button>
        </template>

      </div>
      
    </div>
    
    <div class="kb-product-card__message" v-if="data.messageLabelText">
      <p>{{ data.messageLabelText }}</p>
    </div>
    
    <template v-if="isSubmitting">
      <div class="kb-spinner-overlay">
        <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
      </div>
    </template>

  </a>
</template>